import qs from "qs";

export type TwitterParams = {
  url?: string;
  text?: string;
  via?: string;
  hashtags?: string;
  related?: string;
};

interface TwitterButtonProps {
  params: TwitterParams;
  className?: string;
  children: React.ReactNode;
}

const DEFAULT_POPUP_OPTIONS = {
  height: 600,
  width: 750,
  location: "no",
  toolbar: "no",
  status: "no",
  directories: "no",
  menubar: "no",
  scrollbars: "yes",
  resizable: "no",
  centerscreen: "yes",
  chrome: "yes",
};

const popupStyles = Object.entries(DEFAULT_POPUP_OPTIONS)
  .map(([key, value]) => `${key}=${value}`)
  .join(",");

export const TwitterButton = ({
  params,
  className,
  children,
}: TwitterButtonProps) => {
  const handleClick = () => {
    const url = `https://twitter.com/intent/tweet?${qs.stringify(params)}`;
    window.open(url, "", popupStyles);
  };

  return (
    <button
      type="button"
      aria-label="Twitter"
      onClick={handleClick}
      className={className}
      css={`
        text-align: left;
        color: inherit;
        background-color: transparent;
        border: none;
      `}
    >
      {children}
    </button>
  );
};
